import { render, staticRenderFns } from "./modalFormSerie.vue?vue&type=template&id=38a0ab88&scoped=true"
import script from "./modalFormSerie.vue?vue&type=script&lang=js"
export * from "./modalFormSerie.vue?vue&type=script&lang=js"
import style0 from "./modalFormSerie.vue?vue&type=style&index=0&id=38a0ab88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a0ab88",
  null
  
)

export default component.exports